module.exports = __webpack_public_path__ + "img/project-apartment-registration-system-3.7ccea7f9.png";